import React, { useEffect } from "react";
import Layout from "../../components/layouts/layout";
import ImageBanner from "../../templates/ImageBanner";
import BannerBgImage from "../../assets/Images/services/services-banner-dark.png";
import FullStackExpertise from "../../components/FullStackExpertise";
import CtaCardSection from "../../components/CTASection/ctaCard2";
import CTAIMAGE1 from "../../assets/Images/Clutch/Cta/phone-contact.png";
import OurModelSection from "../../components/OurModelSection";
import PracticesSection from "../../components/PracticesSection";
import TwoColumnContactInfo from "../../templates/TwoColumnContactInfo";
import Clm1Img from "../../assets/Icons/phone.svg";
import Clm2Img from "../../assets/Icons/mail.svg";
import axios from "axios";

function ServicesPage() {
  const ImageBannerData = {
    bnrImg: BannerBgImage,
    bnrImgTitle: (
      <>
        Offering Bespoke <br /> Advanced Tech Solutions.
      </>
    ),
    bnrImgSubTitle: (
      <>
        We craft seamless experiences to inspire <br /> growth and success.
      </>
    ),
    autoWidth: true,
    component: "Who",
    downArrow: false,
    subtitleclassname: "serviceBannerTitle",
    parentClass: "servicePage",
    servicesColumn1: {
      data: [],
    },
    servicesColumn2: {
      data: [],
    },
    servicesColumn3: {},
  };
  const TwoColumnContactInfoData = {
    Clm1Img: Clm1Img,
    Clm1Title: "Phone:",
    Clm1SubTitle: "+44 (0) 161 706 7983",
    Clm2Img: Clm2Img,
    Clm2Title: "Email:",
    Clm2SubTitle: "hello@digiryte.com",
  };

  // const handeClick = async () => {
  //   await axios
  //     .get(
  //       `https://yjk6ecgf.apicdn.sanity.io/v2023-01-01/data/query/production?query=*%5B_type%20%3D%3D%20%22serviceslandingPage%22%20%26%26%20isActive%20%3D%3D%20true%5D%20%7B%0A%20%20slug%2C%0A%20%20title%0A%7D`
  //     )
  //     .then((response) => {
  //       console.log(response.data.result, "response-----");
  //     });
  // };

  // useEffect(() => {
  //   handeClick();
  // }, []);

  return (
    <Layout
      seo={{
        title: "Digital Transformation & Software Development Services",
        ogtitle: "Digital Transformation & Software Development Services",
        description:
          "Explore Digiryte's consulting, audit, and build services driving digital innovation, performance, and scalability.",
      }}
      ogurl="https://www.digiryte.com/services"
      type="service"
    >
      <ImageBanner imageBannerData={ImageBannerData} />
      <FullStackExpertise
        parentWarp="services-modal-wrap"
        title="Services"
        showButton={false}
        isServiceCard
      />
      <PracticesSection />
      <div className="mt-70 common-o-bg">
        <CtaCardSection
          className=""
          title={
            <>
              <span className="animationTitle">We are </span>
              engaged with <br /> technology in our lives.
            </>
          }
          imageUrl={CTAIMAGE1}
          imgClassName="custom-cta-img custom-cta-darken"
        />
      </div>
      <OurModelSection />

      <div className="mt-70">
        <TwoColumnContactInfo
          TwoColumnContactInfoData={TwoColumnContactInfoData}
        />
      </div>
    </Layout>
  );
}

export default ServicesPage;
